export const teamMembers = [
  {
    name: "沈书言",
    role: "主编 / 选片",
    bio: "曾任职于釜山国际电影节策展组，负责韩国伦理题材影片的年度片单整理与专题策划。",
    initials: "SY",
  },
  {
    name: "林知夏",
    role: "内容编辑",
    bio: "专注韩国家庭与社会题材电影评论，撰写影片资料、导演访谈与观影指南。",
    initials: "ZX",
  },
  {
    name: "崔允在",
    role: "影像顾问",
    bio: "首尔独立影像研究者，为站点提供韩国电影产业动态与影展资讯支持。",
    initials: "YJ",
  },
  {
    name: "周默",
    role: "技术体验",
    bio: "负责播放界面、检索体验与站点性能，让每一次找片都更顺畅。",
    initials: "ZM",
  },
];

export const friendlyLinks = [
  { name: "釜山国际电影节", desc: "亚洲重要影展官方资讯" },
  { name: "韩国电影振兴委员会", desc: "韩国电影产业公开数据" },
  { name: "首尔独立影像馆", desc: "独立与艺术电影放映资讯" },
  { name: "韩影资料馆", desc: "影片档案与影人年表" },
  { name: "光影手记", desc: "华语影评人专栏合集" },
  { name: "银幕之外", desc: "电影幕后与制作观察" },
];

export const contentScope = [
  {
    icon: "ri-film-line",
    title: "影片资料整理",
    desc: "收录影片的中文片名、韩文原名、导演、主演、片长、上映时间与剧情简介，信息统一校对。",
  },
  {
    icon: "ri-layout-grid-line",
    title: "分类与检索",
    desc: "按剧情、爱情、社会三大方向分类，支持年份、评分与关键词组合检索，快速定位想看的影片。",
  },
  {
    icon: "ri-play-circle-line",
    title: "观影界面演示",
    desc: "提供完整的播放器界面与交互演示，用于展示观影流程，当前不提供真实片源与在线播放服务。",
  },
  {
    icon: "ri-bookmark-line",
    title: "本地片单",
    desc: "收藏功能仅保存在你的浏览器中，不收集账号信息，也不会上传到任何服务器。",
  },
];

export const siteFaq = [
  {
    q: "网站上的影片可以直接观看吗？",
    a: "目前播放区域为界面与交互演示，用于展示观影流程与页面结构，暂未接入真实片源。影片资料、评分与简介均为虚构示例内容。",
  },
  {
    q: "收藏的影片会保存多久？",
    a: "收藏记录保存在当前浏览器的本地存储中，清除浏览器数据后会一并移除。更换设备或浏览器不会同步。",
  },
  {
    q: "影片信息多久更新一次？",
    a: "资料库会按季度整理，补充新片条目并校对已有影片的导演、主演与片长信息。",
  },
  {
    q: "可以推荐影片或提交片单吗？",
    a: "可以通过联系页面提交想看的影片或专题建议，编辑团队会在整理片单时参考。",
  },
];